import { Link } from 'react-router-dom';
import { PUBLIC_DEMO_PATH } from './landingContent';
const plans = [{
  name: 'Public preview',
  code: 'START EXPLORING',
  description: 'See how the workspace fits your research.',
  price: 'No account needed',
  items: ['Public signal dashboard', 'Available public signal previews', 'Explore before requesting access'],
  cta: 'Explore the dashboard',
  path: PUBLIC_DEMO_PATH
}, {
  name: 'Basic',
  code: 'SELECTED SIGNAL ACCESS',
  description: 'Request the signal access that fits your workflow.',
  price: 'Request current pricing',
  items: ['Approved account access', 'Signals assigned to your plan', 'Subscription requests reviewed by an administrator'],
  cta: 'Request Basic access',
  path: '/signup'
}, {
  name: 'Premium',
  code: 'EXPAND YOUR WORKSPACE',
  description: 'Request broader access to premium signal families.',
  price: 'Request current pricing',
  items: ['Approved account access', 'Eligible premium signals and groups', 'Access based on configured plan entitlements'],
  cta: 'Request Premium access',
  path: '/signup',
  featured: true
}];
export default function PricingSection({
  isLoggedIn
}) {
  return <section className="sf-section sf-plans-section" id="plans" aria-labelledby="sf-plans-title"><div className="sf-container"><div className="sf-section-heading"><p className="sf-eyebrow">EXPLORE FIRST. CHOOSE YOUR ACCESS.</p><h2 id="sf-plans-title">A starting point for your workflow.</h2><p>Compare the public preview with registered access. Pricing, duration, and included signals are confirmed before subscription activation.</p></div><div className="sf-plans-grid">{plans.map(plan => <article className={`sf-plan ${plan.featured ? 'sf-plan-featured' : ''}`} key={plan.name}><p className="sf-eyebrow">{plan.code}</p><h3>{plan.name}</h3><p>{plan.description}</p><strong className="sf-plan-price">{plan.price}</strong><ul>{plan.items.map(item => <li key={item}>{item}</li>)}</ul><Link className={`sf-button ${plan.featured ? 'sf-button-primary' : 'sf-button-outline'}`} to={isLoggedIn && plan.path === '/signup' ? '/app' : plan.path}>{isLoggedIn && plan.path === '/signup' ? 'Manage access in your account' : plan.cta}</Link></article>)}</div><p className="sf-small sf-plan-note">Plan access does not automatically enable trading. Crypto execution requires separate permissions; Forex remains signals-only.</p></div></section>;
}
